/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.aiHistorique.ts
 *
 * Historique de l'usage de l'IA dans l'écran IA (2026-10-09, Mika : « si
 * l'historique, le détail du coût n'existe pas, il faut le créer pour
 * l'avenir »). Fusionné dans fr.ts. Aucun tiret cadratin.
 *
 * Mikael - chef de projet - 2026-10-09
 */
export const messagesAiHistoriqueFr: Record<string, string> = {
  'aiHisto.titre': 'Historique de l’IA',
  'aiHisto.intro':
    'Tout ce que l’IA a fait depuis sa mise en service, jour par jour et fonction par fonction : les appels servis par l’IA, les replis sans IA, les jetons et le coût estimé. Cliquez sur un mois pour en voir le détail.',
  'aiHisto.chargement': 'Chargement de l’historique…',
  'aiHisto.erreur': 'L’historique n’a pas pu être chargé. Réessayez dans un instant.',
  'aiHisto.vide': 'Aucun usage de l’IA n’est encore enregistré.',
  'aiHisto.totaux': 'Totaux depuis le premier jour',
  'aiHisto.total.appels': 'appels servis par l’IA',
  'aiHisto.total.replis': 'replis sans IA',
  'aiHisto.total.jetons': 'jetons échangés',
  'aiHisto.total.cout': 'coût estimé depuis le début',
  'aiHisto.periode': 'Du {debut} au {fin}.',
  'aiHisto.parMois': 'Par mois',
  'aiHisto.parFonctionTout': 'Par fonction, depuis le début',
  'aiHisto.parFonctionMois': 'Par fonction, {mois}',
  'aiHisto.parJour': 'Par jour, {mois}',
  'aiHisto.jourVide': 'Aucun usage ce mois-ci.',
  'aiHisto.col.mois': 'Mois',
  'aiHisto.col.fonction': 'Fonction',
  'aiHisto.col.jour': 'Jour',
  'aiHisto.col.appels': 'Appels IA',
  'aiHisto.col.replis': 'Replis',
  'aiHisto.col.jetons': 'Jetons',
  'aiHisto.col.cout': 'Coût estimé',
  'aiHisto.toutAfficher': 'Revenir à l’historique complet',
  'aiHisto.exporter': 'Exporter en CSV',
  'aiHisto.estimation':
    'Coût estimé à partir du tarif de chaque modèle, pas une facture. Un repli est une demande servie sans IA (fonction coupée, consentement absent, fournisseur en échec) : il ne coûte rien.',
};
